import { HStack, Image, Text } from "@chakra-ui/react";

import { Task } from "@/types";

export const FeaturingAppsSection = ({ tasks }: { tasks: Task[] }) => {
  const uniqueItemList: { [key: string]: { iconUrl: string; title: string } } = {};
  tasks.forEach((task) => {
    if (task.relatedApp?.title) {
      uniqueItemList[task.relatedApp.title] = {
        iconUrl: task.iconUrl,
        title: task.relatedApp.title,
      };
    }
  });

  return (
    <HStack gap={4} maxW="calc(100vw - 16px)" w="full">
      <Text color="text.secondary">Featuring</Text>
      <HStack gap={2} w="full" overflowX="auto" className="hide-scrollbar">
        {Object.values(uniqueItemList).map(({ iconUrl, title }) => {
          return (
            <HStack
              key={iconUrl + "-" + title}
              gap={2}
              bg="white"
              rounded="full"
              py={2}
              px={3}
              whiteSpace="nowrap"
              flexShrink={0}
            >
              <Image src={iconUrl} boxSize={6} />
              <Text>{title}</Text>
            </HStack>
          );
        })}
      </HStack>
    </HStack>
  );
};
